// <div data-controller="market--fonts--show--slider">
//
// </div>
import {Controller} from "@hotwired/stimulus";
import Splide from "@splidejs/splide";

export default class extends Controller {
  static targets = [
      "slider", "track",
      "controllerSlider", "controllerTrack"
  ];
  static classes = [ "" ]
  static values = {
    height: Number
  };

  initialize() {
    this.slider = null;
    this.controllerSlider = null;
  }

  get slidersCount() {
    return this.trackTarget.querySelectorAll(".splide__slide").length
  }

  connect() {
    // Use requestAnimationFrame to ensure smooth initialization after render
    requestAnimationFrame(() => {
      this.initializeSlider();
    });
  }

  initializeSlider() {
    this.controllerSlider = new Splide(this.controllerSliderTarget, {
      fixedWidth  : 100,
      fixedHeight : 50,
      gap         : 10,
      rewind      : true,
      pagination  : false,
      arrows: false,
      isNavigation: true,
      breakpoints : {
        600: {
          fixedWidth : 50,
          fixedHeight: 25,
        },
      },
    });

    this.slider = new Splide(this.sliderTarget, {
      type: "fade",
      perPage: 1,
      gap: "1rem",
      rewind : true,
      pagination: false,
      padding: 0,
      // fixedHeight: this.heightValue,
      heightRatio: 0.5,
      arrows: true,
    });

    this.slider.sync(this.controllerSlider)
    this.slider.mount();
    this.controllerSlider.mount();
  }

  disconnect() {
    if (this.slider) {
      this.slider.destroy();
    }
  }
}
